import { c as _c } from "react/compiler-runtime";
import { useLoading } from "@website/ui/loading/loading.hook";
import styles from "@website/ui/loading/loading.module.scss";
import { LoadingPropertiesType } from "@website/ui/loading/loading.types";
import { FC } from "react";
export const Loading: FC<LoadingPropertiesType> = properties => {
  const $ = _c(11);
  const {
    rootProps
  } = useLoading();
  const {
    color: t0,
    size: t1,
    children,
    className
  } = properties;
  const color = t0 === undefined ? "primary" : t0;
  const size = t1 === undefined ? "lg" : t1;
  let t2;
  if ($[0] !== children) {
    t2 = children ? <span>{children}</span> : null;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${styles.container} ${className} ${styles[color]} ${styles[size]}`;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={`${styles.dot} ${styles.odd}`} />;
    t5 = <span className={`${styles.dot} ${styles.even}`} />;
    t6 = <span className={`${styles.dot} ${styles.odd}`} />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== rootProps || $[6] !== t3) {
    t7 = <span {...rootProps} className={t3}>{t4}{t5}{t6}</span>;
    $[5] = rootProps;
    $[6] = t3;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t7) {
    t8 = <>{t2}{t7}</>;
    $[8] = t2;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};